import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Mail, Phone } from 'lucide-react';

const About = () => {
  return (
    <div className="heritage-page min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1">
        <section
          className="relative overflow-hidden"
          style={{
            backgroundImage: "url('/aboutus.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
          data-testid="about-hero"
        >
          <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(22,13,10,0.58),rgba(24,15,11,0.72)_28%,rgba(28,18,13,0.78)_62%,rgba(19,11,8,0.86))]"></div>
          <div className="absolute inset-0 opacity-35 vintage-grain"></div>

          <div className="relative z-10 mx-auto flex min-h-[calc(100vh-5rem)] max-w-6xl items-center px-6 py-16 sm:px-10 lg:px-16">
            <div className="w-full">
              <div className="max-w-3xl">
                <p className="mb-4 text-xs uppercase tracking-[0.34em] text-[#e4bf7a]">Our Story</p>
                <p className="max-w-2xl text-base leading-8 text-[#f5e9d8] sm:text-lg">
                  Panchami is dedicated to preserving and celebrating the rich heritage of South Indian jewelry.
                  Each piece in our collection tells a story of tradition, craftsmanship, and timeless beauty.
                </p>
                <p className="mt-4 max-w-2xl text-base leading-8 text-[#f0dfc9] sm:text-lg">
                  From intricate temple jewelry to contemporary designs inspired by our cultural roots, we bring
                  you authentic pieces that connect you to the essence of South Indian artistry.
                </p>
              </div>

              <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
                <div className="rounded-sm border border-[#e2c089]/30 bg-[rgba(49,31,23,0.42)] p-6 text-center backdrop-blur-[2px]">
                  <h3 className="font-heading text-2xl text-[#f4d396]">Authenticity</h3>
                  <p className="mt-2 text-sm leading-7 text-[#f4e5d0]">Genuine South Indian designs crafted with care</p>
                </div>
                <div className="rounded-sm border border-[#e2c089]/30 bg-[rgba(49,31,23,0.42)] p-6 text-center backdrop-blur-[2px]">
                  <h3 className="font-heading text-2xl text-[#f4d396]">Quality</h3>
                  <p className="mt-2 text-sm leading-7 text-[#f4e5d0]">Premium materials and expert craftsmanship</p>
                </div>
                <div className="rounded-sm border border-[#e2c089]/30 bg-[rgba(49,31,23,0.42)] p-6 text-center backdrop-blur-[2px]">
                  <h3 className="font-heading text-2xl text-[#f4d396]">Tradition</h3>
                  <p className="mt-2 text-sm leading-7 text-[#f4e5d0]">Honoring centuries-old jewelry-making heritage</p>
                </div>
              </div>

              <div className="mt-12 max-w-4xl border-t border-[#e2c089]/30 pt-10">
                <h2 className="text-2xl font-heading font-normal text-white sm:text-3xl lg:text-4xl">
                  Get in Touch
                </h2>

                <div className="mt-8 grid grid-cols-1 gap-8 md:grid-cols-2">
                  <div className="flex flex-col items-start" data-testid="contact-phone">
                    <Phone className="h-8 w-8 text-[#f0c26b]" />
                    <h3 className="mt-3 font-heading text-lg text-[#f8ead4]">Call Us</h3>
                    <a href="tel:+917760078388" className="mt-2 text-[#f2e2c7] transition-colors hover:text-white">
                      +91 77600 78388
                    </a>
                  </div>

                  <div className="flex flex-col items-start" data-testid="contact-email">
                    <Mail className="h-8 w-8 text-[#f0c26b]" />
                    <h3 className="mt-3 font-heading text-lg text-[#f8ead4]">Email Us</h3>
                    <a href="mailto:panchamimallyabellare@gmail.com" className="mt-2 break-all text-[#f2e2c7] transition-colors hover:text-white">
                      panchamimallyabellare@gmail.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default About;
